import React from "react";
import "../css/footer.css";

export const Footer = () => (
  <footer className="site-footer">
    <div className="footer-divider" />
    <div className="footer-brand">Makite Desta</div>

    <div className="footer-links">
      <a
        href="https://www.facebook.com/maki.man.106"
        target="_blank"
        rel="noreferrer"
      >
        Facebook
      </a>
      <a
        href="https://www.instagram.com/makimanmtu/"
        target="_blank"
        rel="noreferrer"
      >
        Instagram
      </a>
      <a
        href="https://www.linkedin.com/in/makite-desta-b0ab8b19b/"
        target="_blank"
        rel="noreferrer"
      >
        LinkedIn
      </a>
      <a href="https://github.com/makite" target="_blank" rel="noreferrer">
        GitHub
      </a>
    </div>

    <span className="footer-copy">
      © {new Date().getFullYear()} Makite Desta. All Rights Reserved.
    </span>
  </footer>
);
